/* istanbul ignore file */
import { CurrencyInput, CurrencyInputProps, useInputHelper } from 'framework/form';
import { CURRENCIES } from 'framework/ui/field';

interface TransferCurrencyInputProps extends Omit<CurrencyInputProps, 'onChangeCallback'> {
  currencySource: string;
  allowNegative?: boolean;
}

const InvoiceTotalInput = ({ currencySource, ...props }: TransferCurrencyInputProps) => {
  const { getValue } = useInputHelper({
    source: currencySource,
  });
  const currency = getValue() as any;

  return <CurrencyInput {...props} maxDecimal={2} suffix={currency ? CURRENCIES[currency] : ''} />;
};

export default InvoiceTotalInput;
